//チェックボックス取得
const checkButtons = Array.from(document.querySelectorAll('.js-check-box'));
//ラジオボタン取得
const radioButtons = Array.from(document.querySelectorAll('.js-radio-box'));
//表示非表示させる要素取得
const checkShowItems = Array.from(document.querySelectorAll('.js-check-show'))
const radioShowItems = Array.from(document.querySelectorAll('.js-radio-show'))

//チェックボックスのクリックイベント
checkButtons.forEach((checkitem) => {
    checkitem.addEventListener('click', (event) => {
        //チェックボックスのdata属性を取得
        let datacheck = checkitem.dataset.checkName;

        //チェックボックスのcheckedがtrueだったら実行
        if (checkitem.checked == true) {
            //data属性と一致する要素にis-openクラスを追加
            checkShowItems.forEach((checkShowItem) => {
                if (checkShowItem.dataset.hideName == datacheck) {
                    checkShowItem.classList.add('is-open')
                }
            })
        } else {
            //data属性と一致する要素からis-openクラスを削除
            checkShowItems.forEach((checkShowItem) => {
                if (checkShowItem.dataset.hideName == datacheck) {
                    checkShowItem.classList.remove('is-open')
                }
            })
            radioButtons.forEach((radioButton) => {
                if(radioButton.checked == true){
                    radioButton.checked = false;
                }
            })
            radioShowItems.forEach((radioShowItem) => {
                if (radioShowItem.dataset.hideName == datacheck) {
                    radioShowItem.classList.remove('is-open')
                }
            })
        }
    })
})

//ラジオボタンのクリックイベント
radioButtons.forEach((radioButton) => {
    radioButton.addEventListener('click', (event) => {
        let dataradio = radioButton.dataset.radioName;
        radioShowItems.forEach((radioShowItem) => {
            if (radioShowItem.dataset.hideRadioName == dataradio) {
                radioShowItem.classList.add('is-open')
            } else {
                radioShowItem.classList.remove('is-open')
            }
        })
    })
})


//ページ読み込み時の処理 チェックボックス
window.addEventListener('DOMContentLoaded', () => {
    checkButtons.forEach((checkitem) => {
        let datacheck = checkitem.dataset.checkName;
        if (checkitem.checked == true) {
            //data属性と一致する要素にis-openクラスを追加
            checkShowItems.forEach((checkShowItem) => {
                if (checkShowItem.dataset.hideName == datacheck) {
                    checkShowItem.classList.add('is-open')
                }
            })
        } else {
            //data属性と一致する要素からis-openクラスを削除
            checkShowItems.forEach((checkShowItem) => {
                if (checkShowItem.dataset.hideName == datacheck) {
                    checkShowItem.classList.remove('is-open')
                }
            })
        }
    })
});
//ページ読み込み時の処理 ラジオボタン
window.addEventListener('DOMContentLoaded', () => {
    radioButtons.forEach((radioButton) => {
            let dataradio = radioButton.dataset.radioName;
            //console.log(dataradio)
            if (radioButton.checked == true) {
                //data属性と一致する要素にis-openクラスを追加
                radioShowItems.forEach((radioShowItem) => {
                    if (radioShowItem.dataset.hideName == dataradio) {
                        radioShowItem.classList.add('is-open');
                    }
                })
            } else {
                //data属性と一致する要素からis-openクラスを削除
                radioShowItems.forEach((radioShowItem) => {
                    if (radioShowItem.dataset.hideName == dataradio) {
                        radioShowItem.classList.remove('is-open');
                    }
                })
            }
    })
})